import { Link } from "react-router-dom";

export default function MantenimientoHero() {
  return (
    <section className="relative min-h-[420px] md:min-h-[560px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <video
          className="w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          src="https://storage.helloreaddy.io/project_files/7ab0d457-3dab-428f-ba9a-e3f3097fe185/ab558693-9359-47b0-a28e-f20f5eb28a89_Tcnico_realizando_mantenimiento_202609021441.mp4"
        />
        <div className="hero-overlay-gradient absolute inset-0" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-28 md:pt-36 pb-12 md:pb-16">
        <div className="max-w-5xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-background-400 mb-6">
            <Link
              to="/"
              className="hover:text-background-200 transition-colors whitespace-nowrap"
            >
              Inicio
            </Link>
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-background-500" />
            <span className="text-background-200 whitespace-nowrap">Servicios</span>
          </nav>

          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#0087a4] text-white text-xs font-bold uppercase tracking-wide mb-5">
            <i className="ri-flashlight-line w-4 h-4 flex items-center justify-center" />
            Temporada de mantenimiento
          </span>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            Evita reparaciones costosas: mant&eacute;n tu aire acondicionado en &oacute;ptimas condiciones
          </h1>

          <p className="text-background-200 text-base md:text-lg max-w-2xl leading-relaxed mb-8">
            Cada d&iacute;a sin mantenimiento te acerca a una aver&iacute;a grave. Protege tu inversi&oacute;n, ahorra hasta un 30% en energ&iacute;a y garantiza aire saludable.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-4">
            <a
              href="https://wa.me/573232209100"
              target="_blank"
              rel="noopener noreferrer"
              className="px-7 py-3.5 rounded-lg bg-[#0087a4] text-white font-semibold text-sm md:text-base hover:bg-[#006f86] transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2" />
              Agenda tu visita
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}